"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FormWrapper = _interopRequireDefault(require("../FormWrapper"));
var _cccisdLaravelNexus = require("cccisd-laravel-nexus");
var _queryVariablesHelper = _interopRequireDefault(require("../../helpers/queryVariablesHelper.js"));
var _rowActionsHelper = _interopRequireDefault(require("../../helpers/rowActionsHelper.js"));
var _setAppdefEnumFilterSettings = _interopRequireDefault(require("../../helpers/setAppdefEnumFilterSettings.js"));
var _cccisdTabletop = _interopRequireDefault(require("cccisd-tabletop"));
var _cccisdTableRenders = _interopRequireDefault(require("cccisd-table-renders"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _omit2 = _interopRequireDefault(require("lodash/omit"));
var _isUndefined2 = _interopRequireDefault(require("lodash/isUndefined"));
var _Buttons = _interopRequireDefault(require("../Buttons"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // import { LicenseRowAction } from 'cccisd-laravel-licensing';
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var rendersContext = require.context('resources/assets/js', true, /^\.\/renders\/([^/]+\/){1}index\.js$/);
var buttonsContext = require.context('resources/assets/js', true, /^\.\/vendor\/app-definitions\/tableButtons\/([^/]+\/){1}index\.js$/);
var RosteringContainer = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function RosteringContainer() {
    var _this;
    _classCallCheck(this, RosteringContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RosteringContainer, [].concat(args));
    _defineProperty(_this, "afterFormSubmit", function () {
      // reload data
      _this.tt.loadData();
      if (_this.props.externalLoadData) {
        _this.props.externalLoadData();
      }
    });
    _defineProperty(_this, "getRenderFromContext", function (context, type) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var renderType = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return type === renderType;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App renderer not found for \"".concat(type, "\" in app"));
      return undefined;
    });
    _defineProperty(_this, "getButtonsFromContext", function (context, handle) {
      if (!context) {
        return function () {};
      }
      var foundKey = (0, _find2["default"])(context.keys(), function (key) {
        var buttonHandle = key.replace(/^.*\/[^/]+\/([^/]+)\/index\.js$/, '$1');
        return handle === buttonHandle;
      });
      if (foundKey) {
        return context(foundKey);
      }
      console.warn("App table button not found for \"".concat(handle, "\" in app"));
      return undefined;
    });
    _defineProperty(_this, "processTable", function (view) {
      var _this$props = _this.props,
        _this$props$content = _this$props.content,
        form = _this$props$content.form,
        routes = _this$props$content.routes,
        type = _this$props$content.type,
        nexusType = _this$props$content.nexusType,
        externalLoadData = _this$props.externalLoadData;
      var cols = [];
      view.table.columns.forEach(function (c) {
        var column = {};
        if ('renderAs' in c) {
          if (c.renderAs.type === 'RosteringButtons') {
            var settings = c.renderAs.settings;
            settings.FormComponent = _FormWrapper["default"];
            settings.formProps = {
              type: type,
              routes: routes,
              form: form,
              afterFormSubmit: _this.afterFormSubmit,
              nexusType: nexusType
            };
            column.render = (0, _cccisdLaravelNexus.RosteringButtons)(settings);
          } else if (c.renderAs.type === 'UnarchiveButton') {
            column.render = (0, _cccisdLaravelNexus.UnarchiveButton)(c.renderAs.settings);
          } else {
            var tmpRender;
            var renderClass = function renderClass() {};
            if (c.renderAs["class"] === 'app') {
              tmpRender = _this.getRenderFromContext(rendersContext, c.renderAs.type);
              if (!(0, _isUndefined2["default"])(tmpRender)) {
                renderClass = tmpRender["default"];
              }
            } else {
              renderClass = _cccisdTableRenders["default"][c.renderAs["class"]][c.renderAs.type];
            }
            column.render = renderClass(c.renderAs.settings);
            column = Object.assign(column, (0, _setAppdefEnumFilterSettings["default"])(c, column));
          }
        }
        cols.push(Object.assign(c, column));
      });
      var variables = {};
      if ('requiredVariables' in view.table) {
        variables = (0, _queryVariablesHelper["default"])(view.table.requiredVariables);
      }
      if (view.table.rowActions) {
        view.table.rowActions = (0, _rowActionsHelper["default"])(view.table.rowActions, externalLoadData);
      }
      return Object.assign((0, _omit2["default"])(view.table, ['columns', 'requiredVariables']), {
        columns: cols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_this, "processBottomTable", function (view) {
      var externalLoadData = _this.props.externalLoadData;
      var bottomCols = [];
      view.bottomTable.columns.forEach(function (bc) {
        var bcolumn = {};
        if ('renderAs' in bc) {
          if (bc.renderAs.type === 'RosteringButtons') {
            bcolumn.render = (0, _cccisdLaravelNexus.RosteringButtons)(bc.renderAs.settings);
          } else if (bc.renderAs.type === 'UnarchiveButton') {
            bcolumn.render = (0, _cccisdLaravelNexus.UnarchiveButton)(bc.renderAs.settings);
          } else {
            var tmpRender;
            var renderClass = function renderClass() {};
            if (bc.renderAs["class"] === 'app') {
              tmpRender = _this.getRenderFromContext(rendersContext, bc.renderAs.type);
              if (!(0, _isUndefined2["default"])(tmpRender)) {
                renderClass = tmpRender["default"];
              }
            } else {
              renderClass = _cccisdTableRenders["default"][bc.renderAs["class"]][bc.renderAs.type];
            }
            bcolumn.render = renderClass(bc.renderAs.settings);
            bcolumn = Object.assign(bcolumn, (0, _setAppdefEnumFilterSettings["default"])(bc, bcolumn));
          }
        }
        bottomCols.push(Object.assign(bc, bcolumn));
      });
      var variables = {};
      if ('requiredVariables' in view.bottomTable) {
        variables = (0, _queryVariablesHelper["default"])(view.bottomTable.requiredVariables);
      }
      if (view.bottomTable.rowActions) {
        view.bottomTable.rowActions = (0, _rowActionsHelper["default"])(view.bottomTable.rowActions, externalLoadData);
      }
      return Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), {
        columns: bottomCols,
        graphqlVariables: variables
      });
    });
    _defineProperty(_this, "processProps", function () {
      var _this$props2 = _this.props,
        tabHandle = _this$props2.tabHandle,
        products = _this$props2.products,
        _this$props2$content = _this$props2.content,
        tableTop = _this$props2$content.tableTop,
        form = _this$props2$content.form,
        routes = _this$props2$content.routes,
        type = _this$props2$content.type,
        nexusType = _this$props2$content.nexusType,
        externalLoadData = _this$props2.externalLoadData,
        hideTopLevelLicensing = _this$props2.hideTopLevelLicensing;

      /* Do a deep clone so the below code does not modify props in place,
       *   but actually makes new object and triggers re-render if props change */
      var tableTopProps = (0, _cloneDeep2["default"])(tableTop);
      if (products && products.length && !tableTopProps.views.some(function (view) {
        return view.table.columns.some(function (v) {
          return v.handle === 'license';
        });
      })) {
        var manageViewIndex = tableTopProps.views.findIndex(function (v) {
          return v.handle === 'manage';
        });
        if (manageViewIndex === -1) {
          manageViewIndex = 0;
        }
        var manageView = tableTopProps.views[manageViewIndex];
        if (manageView) {
          var _tableTopProps$views;
          var manageViews = [];
          products.forEach(function (product) {
            var productId = product.productId,
              handle = product.handle,
              label = product.label,
              duration = product.duration;
            // we're modifying some nested keys, so safer to deep copy
            var viewPerProduct = (0, _cloneDeep2["default"])(manageView);
            viewPerProduct.handle += product.productId;
            viewPerProduct.title = product.label;
            if (!hideTopLevelLicensing) {
              viewPerProduct.helperText = products.length === 1 ? "".concat(product.ownedLicenseCount, " license").concat(product.ownedLicenseCount === 1 ? '' : 's', " in use for ").concat(product.label) : "".concat(product.ownedLicenseCount, " license").concat(product.ownedLicenseCount === 1 ? '' : 's', " in use");
            }
            viewPerProduct.productId = productId;
            viewPerProduct.productHandle = handle;
            var existingVariables = (0, _get2["default"])(viewPerProduct, 'table.requiredVariables', []) || [];
            viewPerProduct.table.requiredVariables = [].concat(_toConsumableArray(existingVariables), [{
              variable: 'productId',
              value: productId
            }]);

            // * The following block concerning Bulk License Assignment via Row Action
            // * has been temporaily disabled until the corresponding backend route(s)
            // * are completed.
            // TODO: RE-ENABLE WHEN COMPLETED

            // const existingRowActions = _get(viewPerProduct, 'table.rowActions', []) || [];
            // if (!existingRowActions.some(rAction => rAction.action === 'license') && nexusType === 'pawn') {
            //     viewPerProduct.table.rowActions = [
            //         ...existingRowActions,
            //         {
            //             ...LicenseRowAction,
            //             title: 'Assign License: ' + label,
            //             component: rowActionProps => (
            //                 <LicenseRowAction.component {...rowActionProps} {...product} />
            //             ),
            //         },
            //     ];
            // }

            var activationStatusColumnIndex = viewPerProduct.table.columns.findIndex(function (col) {
              var _col$renderAs;
              return col.handle === 'activationStatus' || (col === null || col === void 0 ? void 0 : (_col$renderAs = col.renderAs) === null || _col$renderAs === void 0 ? void 0 : _col$renderAs.type) === 'AccountActivation';
            });
            var actionsColumnIndex = viewPerProduct.table.columns.findIndex(function (col) {
              var _col$renderAs2;
              return col.handle === 'actions' || (col === null || col === void 0 ? void 0 : (_col$renderAs2 = col.renderAs) === null || _col$renderAs2 === void 0 ? void 0 : _col$renderAs2.type) === 'RosteringButtons';
            });
            var hideLicensingButton = false;
            if ('hideLicensingButton' in _this.props.content && _this.props.content.hideLicensingButton) {
              hideLicensingButton = true;
            }
            var hideLicensingColumn = false;
            if ('hideLicensingColumn' in _this.props.content && _this.props.content.hideLicensingColumn) {
              hideLicensingColumn = true;
            }
            if (nexusType === 'pawn' && !hideLicensingColumn) {
              var indexToSplice = activationStatusColumnIndex;
              if (indexToSplice === -1) {
                indexToSplice = actionsColumnIndex;
              }
              viewPerProduct.table.columns.splice(indexToSplice + 1, 0, {
                handle: 'license',
                label: 'License',
                name: 'ownedLicenseList',
                renderAs: {
                  "class": 'string',
                  settings: {
                    productId: productId
                  },
                  type: 'LicenseStatus'
                },
                filter: true,
                filterSettings: {
                  type: 'selectbox',
                  field: 'licenseStatus',
                  options: [{
                    label: 'None',
                    value: 'none'
                  }, {
                    label: 'Active',
                    value: 'active'
                  }, {
                    label: 'Expired',
                    value: 'expired'
                  }]
                }
              });
            }
            if (nexusType === 'group' && !hideLicensingColumn) {
              viewPerProduct.table.columns.splice(actionsColumnIndex + 1, 0, {
                handle: 'license',
                label: 'Available Licenses',
                tooltip: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, "Available Licenses"), " refers to the number of licenses remaining at this time. This number will decrease as Licenses are used."),
                name: 'availableLicenseCount',
                filter: false,
                sort: false,
                className: 'text-center',
                // custom render to make it more developer friendly
                // in case they forgot to update the manage queries
                render: function render(_ref) {
                  var value = _ref.value,
                    row = _ref.row;
                  if (!('availableLicenseCount' in row)) {
                    console.error('Must add variable `$productId` and field ' + '`availableLicenseCount` to this graphql query');
                  }
                  return !value && value !== 0 ? '-' : value;
                }
              });

              // we don't want default sort to be "Available Licenses" or "License In Use"
              if (!viewPerProduct.table.orderBy) {
                var defaultSort = viewPerProduct.table.columns.find(function (col) {
                  return col.sort && !['license', 'licensesInUse'].includes(col.handle);
                });
                viewPerProduct.table.orderBy = defaultSort ? defaultSort.name : '';
              }
            }
            if (actionsColumnIndex !== -1 && !hideLicensingButton) {
              viewPerProduct.table.columns[actionsColumnIndex].renderAs.settings.buttons.push(nexusType === 'pawn' ? {
                type: 'pawnLicensing',
                settings: {
                  productId: productId,
                  label: label,
                  duration: duration
                }
              } : {
                type: 'groupLicensing',
                settings: {
                  products: [product],
                  isActionButton: true
                }
              });
            }
            manageViews.push(viewPerProduct);
          });
          (_tableTopProps$views = tableTopProps.views).splice.apply(_tableTopProps$views, [manageViewIndex, 1].concat(manageViews));
        }
      }
      var views = [];
      tableTopProps.views.forEach(function (view) {
        var newView = (0, _omit2["default"])(view, ['table', 'bottomTable']);

        // columns
        var table = _this.processTable(view);
        if ('bottomTable' in view) {
          var bottomTable = _this.processBottomTable(view);
          newView.bottomTable = Object.assign((0, _omit2["default"])(view.bottomTable, ['columns']), bottomTable);
        }

        // buttons
        var buttons = [];
        if (!('hideAddButton' in _this.props.content) || 'hideAddButton' in _this.props.content && !_this.props.content.hideAddButton) {
          // If the view is for a product, need CreateButton to be aware of the productId
          var createButtonForm = (0, _cloneDeep2["default"])(form);
          if (view.productId && 'create' in createButtonForm.graphql) {
            var productIdVariable = {
              variable: 'productId',
              value: view.productId
            };
            createButtonForm.graphql.create.requiredVariables = [].concat(_toConsumableArray(createButtonForm.graphql.create.requiredVariables || []), [productIdVariable]);
          }
          buttons.push(function (_ref2) {
            var loadData = _ref2.loadData;
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.CreateButton, {
              FormComponent: _FormWrapper["default"],
              formProps: {
                form: createButtonForm,
                type: type,
                routes: routes,
                afterFormSubmit: _this.afterFormSubmit
              },
              settings: {
                className: 'btn btn-primary',
                buttonText: "Add ".concat(type),
                modalTitle: "Add New ".concat(type)
              },
              withIcon: true,
              disabled: _this.props.content.disableAddButton,
              disabledTooltip: _this.props.content.disableAddButtonTooltip
            });
          });
        }
        if ('bulkHandle' in _this.props.content) {
          var bulkButtonText = "Bulk Add ".concat(type);
          if ('bulkButtonText' in _this.props.content) {
            bulkButtonText = _this.props.content.bulkButtonText;
          }
          buttons.push(function (_ref3) {
            var loadData = _ref3.loadData;
            var loadAllData = function loadAllData() {
              loadData();
              if (externalLoadData) {
                externalLoadData();
              }
            };
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.BulkUploader, {
              handle: _this.props.content.bulkHandle,
              trigger: /*#__PURE__*/_react["default"].createElement("button", {
                type: "button",
                className: "btn btn-primary"
              }, bulkButtonText),
              loadData: loadAllData
            });
          });
        }
        if ('selfRosterLinkButton' in _this.props.content && _this.props.content.nexusType === 'pawn') {
          var redirectPath = _this.props.content.selfRosterLinkButton.redirectPath || '';
          var redirectUrl = null;
          if (redirectPath) {
            redirectUrl = Boilerplate.url(redirectPath);
          }
          buttons.push(function (_ref4) {
            var loadData = _ref4.loadData;
            return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelNexus.SelfRosterLinkButton, _extends({
              role: type,
              roleHandle: tabHandle,
              product: {
                label: view.title,
                handle: view.productHandle
              }
            }, _this.props.content.selfRosterLinkButton, {
              redirectUrl: redirectUrl
            }));
          });
        }
        if ('buttons' in view) {
          view.buttons.forEach(function (b) {
            var Button;
            if ('componentHandle' in b) {
              var tmpButton = _this.getButtonsFromContext(buttonsContext, b.componentHandle);
              if (!(0, _isUndefined2["default"])(tmpButton)) {
                Button = tmpButton["default"];
              }
            } else {
              Button = _Buttons["default"][b.name];
            }
            buttons.push(function (_ref5) {
              var loadData = _ref5.loadData;
              var loadAllData = function loadAllData() {
                loadData();
                if (externalLoadData) {
                  externalLoadData();
                }
              };
              return /*#__PURE__*/_react["default"].createElement(Button, {
                settings: b.settings,
                loadData: loadAllData
              });
            });
          });
        }
        if ('tableDescription' in view) {
          newView.tableDescription = view.tableDescription;
        }
        newView.buttons = buttons;
        newView.table = Object.assign((0, _omit2["default"])(view.table, ['columns']), table);
        views.push(newView);
      });
      return {
        views: views,
        handle: tableTopProps.handle,
        saveState: tableTopProps.saveState
      };
    });
    return _this;
  }
  _inherits(RosteringContainer, _React$Component);
  return _createClass(RosteringContainer, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdTabletop["default"], _extends({
        isAppDefsManage: this.props.isAppDefsManage,
        ref: function ref(input) {
          _this2.tt = input;
        }
      }, this.processProps(), {
        externalLoadData: this.props.externalLoadData,
        selectedProductId: this.props.selectedProductId,
        setSelectedProductId: this.props.setSelectedProductId
      })));
    }
  }]);
}(_react["default"].Component);
_defineProperty(RosteringContainer, "propTypes", {
  /**
   * content json for view
   */
  tabHandle: _propTypes["default"].string,
  content: _propTypes["default"].object.isRequired,
  externalLoadData: _propTypes["default"].func,
  products: _propTypes["default"].array,
  isAppDefsManage: _propTypes["default"].bool,
  hideTopLevelLicensing: _propTypes["default"].bool,
  selectedProductId: _propTypes["default"].number,
  setSelectedProductId: _propTypes["default"].func
});
_defineProperty(RosteringContainer, "defaultProps", {
  products: [],
  setSelectedProductId: function setSelectedProductId() {}
});